<template>
  <ul class="side-nav sidenav" ref="sidenav">
    <li v-if="isLogin && hasPermission">
      <router-link class=" grey-text text-darken-3 waves-effect" style="cusor:pointer" :to="{ name: 'admin' }">
        <i class="material-icons-outlined  grey-text text-darken-3">admin_panel_settings</i>
        Administrator
      </router-link>
    </li>
    <!-- v-show="item.auth_required && isLogin"  -->
    <li v-for="(item, index) in nav.items" :key="index"
      :class="[item.children ? 'no-padding' : '', { hide: item.hp_required && hpProgress === '0' }]">
      <router-link v-if="!item.click.action && !item.children" :to="item.click.route" class="waves-effect sidenav-close">
        <i class="material-icons-outlined left" v-html="item.icon" v-if="item.icon"></i>
        <span v-html="item.name"> </span>
      </router-link>
      <a @click="item.click.action" v-else-if="!item.children" class="waves-effect sidenav-close">
        <i class="material-icons-outlined left" v-html="item.icon" v-if="item.icon"></i>
        <span v-html="item.name"> </span>
      </a>
      <ul v-else-if="item.children" class="collapsible collapsible-accordion">
        <li class="active">
          <a class="collapsible-header">
            <i class="material-icons-outlined left" v-if="item.icon" v-html="item.icon"></i>
            <span v-html="item.name"></span>
            <i class="material-icons right no-margins no-padding">arrow_drop_down</i></a>
          <div class="collapsible-body">
            <ul>
              <li v-for="(child, i) in item.children" :key="(i + 1) * 1.9" class="">
                <router-link v-if="!child.click.action" :to="child.click.route" class="waves-effect sidenav-close">
                  <span v-html="child.name"></span>
                </router-link>
                <!--    <a @click="child.click.action" v-else v-html="child.name" class="waves-effect sidenav-close"> </a> -->
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </li>
    <li>
      <router-link :to="{ name: 'Welcome', query: { start: 2 } }"><i
          class="material-icons-outlined grey-text text-darken-3">help</i> About</router-link>
    </li>
    <li>
      <!-- <a @click="$_logout()" v-if="isLogin" class=" grey-text text-darken-3 waves-effect" style="cusor:pointer">
        <i class="material-icons-outlined  grey-text text-darken-3">exit_to_app</i>
        Signout
      </a> -->
      <!-- <router-link v-else :to="{ name: 'Login' }" class=" grey-text text-darken-3 waves-effect" style="cusor:pointer">
        <i class="material-icons-outlined  grey-text text-darken-3">login</i>
        Login
      </router-link> -->
    </li>

  </ul>
</template>
<script>
import { logout } from "@/api/user.api";
import M from "materialize-css";
export default {
  name: "sideNav",
  data() {
    return {
      nav: {
        collapsibleInstance: null,
        items: [
          {
            name: "App Home",
            auth_required: true,
            icon: `home`,
            click: {
              route: { name: "Home" },
              action: false,
            },
          },
          {
            name: "Resource Centre",
            auth_required: true,
            icon: `emoji_objects`,
            click: {
              route: { name: "resourceCenter" },
              action: false,
            },
          },
          {
            key: "home_profile",
            name: "Home Profile",
            auth_required: true,
            icon: `house`,
            click: {
              route: { name: "HomeProfile" },
              action: false,
            },
          },
          {
            name: "Hazard Assessments",
            auth_required: true,
            /*  icon: `assessment`, */
            hp_required: true,
            click: {
              route: { name: "Home" },
              action: false,
            },
            children: [
              {
                key: "wind_hazard",
                name: "Wind Hazard Assessment",
                click: {
                  route: { name: "WindHazardSurvey" },
                  action: false,
                },
              },
              {
                key: "flood_hazard",
                name: "Flood Hazard Assessment",
                click: {
                  route: { name: "FloodHazardSurvey" },
                  action: false,
                },
              },
              {
                key: "water_hazard",
                name: "Water Shortage Hazard Assessment",
                click: {
                  route: { name: "WaterHazardSurvey" },
                  action: false,
                },
              },
            ],
          },
          {
            key: "energy_calculator",
            name: "Household Carbon Footprint Calculator",
            auth_required: true,
            hp_required: true,
            click: {
              route: { name: "energyCalculator" },
              action: false,
            },
          },
          {
            key: "assessment_summary",
            auth_required: true,
            hp_required: true,
            name: "Climate Change Assessment Summary",
            click: {
              route: { name: "summary" },
              action: false,
            },
          },
          {
            key: "adaptation_plan",
            auth_required: true,
            hp_required: true,
            name: "Adaptation Plan",
            click: {
              route: { name: "adaptationPlan" },
              action: false,
            },
          },
          // {
          //   key: "competition",
          //   auth_required: true,
          //   name: "Enter the Competition",
          //   click: {
          //     route: { name: "competition" },
          //     action: false,
          //   },
          // },
          {
            name: "Settings",
            auth_required: true,
            icon: `settings`,
            click: {
              route: { name: "Account" },
              action: false,
            },
          },
        ],
        instance: null,
        options: {
          edge: "right",
        },
      },
    };
  },
  mounted() {
    this.$_initSideNav();
  },
  computed: {
    isLogin() {
      return this.$store.state.User.isLogin;
    },
    hpProgress() {
      return this.$store.getters["User/homeProfileProgress"];
    },
    hasPermission() {
      const allowedRoles = ["administrator", "editor", "competition_admin"];
      const userRoles = this.$store.state.User.user.roles;
      if (!userRoles) return false;

      const isAllowed = userRoles.reduce((result, item) => {
        if (!result) {
          result = allowedRoles.some((role) => role === item);
        }
        return result;
      }, false);

      if (!isAllowed) return false;

      return true;
    },
  },
  beforeDestroy() {
    /*  this.nav.collapsibleInstance.destroy() */
    this.nav.instance.destroy();
  },
  methods: {
    $_logout() {
      this.$store.commit("User/LOAD_DEFAULT");
      this.$store.commit("Surveys/LOAD_DEFAULT");
      logout().then((x) => {
        this.$router.push({ path: "/login" });
      });
    },
    $_open() {
      this.nav.instance.open();
    },
    $_close() {
      this.nav.instance.close();
    },
    $_initSideNav() {
      this.nav.instance = M.Sidenav.init(this.$refs.sidenav, this.nav.options);

      setTimeout(() => {
        let colEl = document.querySelectorAll(".collapsible");
        this.nav.collapsibleInstance = M.Collapsible.init(colEl, {
          // specify options here
        });
      }, 100);
    },
  },
};
</script>
<style scoped lang="scss">
.side-nav {
  padding-top: 64px !important;
  padding-bottom: 128px;

  @media screen and (max-width: 1024px) {
    padding-top: 56px !important;
  }

  li {
    &.active {
      ul {
        background: rgba(0, 0, 0, 0.05);
      }
    }

    a {
      padding: 0px 30px;

      i {
        margin-right: 10px;
      }

      span {
        display: inline-block;
        line-height: 1.3;
        margin-top: 10px;
      }
    }
  }

  .collapsible-header {
    padding: 0 30px;

    i {
      margin-right: 0px;
    }
  }

  .collapsible-body {
    ul {
      li {
        a {
          padding-left: 46px;
        }
      }
    }
  }
}
</style>
